import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useQueryParams = (): {
    setQueryParams: (params: Record<string, string>) => void;
    updateQueryParams: (params: Record<string, string>) => void;
} => {
    const navigate = useNavigate();
    const location = useLocation();

    const setQueryParams = useCallback(
        (params: Record<string, string>) => {
            const urlSearchParams = new URLSearchParams(params);
            navigate({ pathname: location.pathname, search: urlSearchParams.toString() }, { replace: true });
        },
        [navigate, location.pathname],
    );

    const updateQueryParams = useCallback(
        (params: Record<string, string>) => {
            const urlSearchParams = new URLSearchParams(location.search);
            for (const [key, value] of Object.entries(params)) {
                urlSearchParams.set(key, value);
            }

            navigate({ pathname: location.pathname, search: urlSearchParams.toString() }, { replace: true });
        },
        [navigate, location.pathname, location.search],
    );

    return {
        setQueryParams,
        updateQueryParams,
    };
};
